import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c899af4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "authentication"
}
const _hoisted_2 = {
  key: 1,
  class: "examine"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "detail_box"
}
const _hoisted_7 = { class: "top" }
const _hoisted_8 = { class: "flex bottom" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用户ID：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注册时间：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "手机号码：", -1))
const _hoisted_12 = {
  key: 1,
  class: "content_top"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "请选择认证类型", -1))
const _hoisted_14 = { class: "switch_mode flex" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "switch_content" }
const _hoisted_17 = { class: "switch_name" }
const _hoisted_18 = { style: {"width":"10%"} }
const _hoisted_19 = { class: "form_info" }
const _hoisted_20 = {
  key: 0,
  style: {"padding":"15px 30px 0"}
}
const _hoisted_21 = { class: "form_box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改", -1))
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "tips" }
const _hoisted_25 = { class: "form_item flex" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "agree" }, [
  /*#__PURE__*/_createTextVNode(" 已经阅读并同意 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.qing.tv/law/statement",
    target: "_blank"
  }, "法律声明"),
  /*#__PURE__*/_createTextVNode("、 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.qing.tv/law/privacy",
    target: "_blank"
  }, "隐私政策"),
  /*#__PURE__*/_createTextVNode("、 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.qing.tv/law/service-agreement",
    target: "_blank"
  }, "直播服务协议"),
  /*#__PURE__*/_createTextVNode("、 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.qing.tv/law/media-storage",
    target: "_blank"
  }, "媒体存储服务协议"),
  /*#__PURE__*/_createTextVNode(" 所述的权利和义务。 ")
], -1))

import { Alert, message, Form, Space, Select, Checkbox, Tooltip } from 'ant-design-vue';
import { DownOutlined, UpOutlined, FormOutlined } from '@ant-design/icons-vue';
import { reactive, ref, shallowRef, UnwrapRef } from 'vue';
import Ccertificates from '@/components/Ccertificates.vue';
import { FileInfo, FormState, modeType, cityData, provinceData, rules, formItem, uploadImg } from './dataJson';
import { ValidateErrorEntity } from 'ant-design-vue/lib/form/interface';
import CLoading from '@/components/CLoading.vue';
import http from '@/api/playback';
import httpcode from '@/api/home';
import { setCertificationStatus } from '@/plugins/cookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const aForm = Form;
const aFormItem = Form.Item;
const aAlert = Alert;
const aSpace = Space;
const aSelect = Select;
const aCheckbox = Checkbox;
const aTooltip = Tooltip;
const tipsMsg = ref('根据相关法规要求，直播间认证需要本人年满18周岁，并亲自实名认证，该认证将履行严格保密义务，请放心上传。');
// 认证状态
const agreeStatus = ref(0);
const showLoading = ref<boolean>(false);
// 直播模式
const selectType = ref(2);
const modeList = shallowRef(modeType);
const getMode = (type: number) => {
  selectType.value = type;
  type == 2 ? (modeList.value[0].checked = true) : (modeList.value[0].checked = false);
  type == 1 ? (modeList.value[1].checked = true) : (modeList.value[1].checked = false);
  type == 1 ? (rules.contact_person[0].required = false) : (rules.contact_person[0].required = true);
  clear();
};

//图片的数组
const fileList = ref([]);
const loading = reactive({
  enterpriseImg: false, //营业执照
  identityUp: false, //身份证正面
  identitydown: false, //身份证反面
});
const frontImg = ref();
const rearImg = ref();
const clearImg = (keyword: string) => {
  keyword == 'enterpriseImg' || keyword == 'identityUp'
    ? ((formState.certificate_front = ''), (frontImg.value = ''))
    : ((formState.certificate_rear = ''), (rearImg.value = ''));
};
const handleChange = (info: FileInfo, keyword: string) => {
  if (info.file.status === 'uploading') {
    loading[keyword] = true;
    return;
  }
  if (info.file.status === 'done') {
    if (info.file?.response?.code != 100) {
      switch (keyword) {
        case 'enterpriseImg':
          frontImg.value = info.file?.response?.data.url;
          formState.certificate_front = info.file?.response?.data.url;
          break;
        case 'identityUp':
          formState.name = JSON.parse(info.file?.response?.data.body).name;
          formState.id_number = JSON.parse(info.file?.response?.data.body).num;
          frontImg.value = info.file?.response?.data.url;
          formState.certificate_front = info.file?.response?.data.url;
          break;
        case 'identitydown':
          rearImg.value = info.file?.response?.data.url;
          formState.certificate_rear = info.file?.response?.data.url;
          break;
      }
    } else {
      message.error(info.file?.response?.error);
    }
    loading[keyword] = false;
  }
  if (info.file.status === 'error') {
    loading[keyword] = false;
    message.error('上传失败');
  }
};

const province = ref(provinceData[0]);
const cities = ref(cityData[province.value]);
const secondCity = ref(cityData[province.value][0]);
const checked = ref<boolean>(false);

const formState: UnwrapRef<FormState> = reactive({
  name: '',
  id_number: '',
  contact_person: '',
  mobile: '',
  address: '',
  industry: secondCity.value,
  certificate_front: '',
  certificate_rear: '',
  certification_type: '',
  code: '',
  status: '',
});
const formRef = ref();
const regInfo = ref();
const oldMobile = ref();
// 下拉
const selectChange = () => {
  cities.value = cityData[province.value];
  secondCity.value = cityData[province.value][0];
};
const selectChangeTwo = () => {
  formState.industry = secondCity.value;
};
const clear = () => {
  province.value = provinceData[0];
  cities.value = cityData[province.value];
  secondCity.value = cityData[province.value][0];
  formRef.value.resetFields();
  formState.mobile = regInfo.value.mobile;
  oldMobile.value = regInfo.value.mobile;
  frontImg.value = '';
  rearImg.value = '';
};
const onSubmit = () => {
  formRef.value
    .validate()
    .then(() => {
      // userAuthentication()
      checked.value ? userAuthentication() : message.error('未勾选阅读并同意法律声明、隐私政策、直播服务协议、媒体存储服务协议');
    })
    .catch((error: ValidateErrorEntity<FormState>) => {
      console.log('error', error);
    });
};
// 提交认证
const userAuthentication = () => {
  viewForm.value = true;
  upView.value = false;
  formState.certification_type = selectType.value;
  formState.industry = secondCity.value;
  formState.certificate_front.indexOf('imgsrc=') != -1
    ? (formState.certificate_front = formState.certificate_front.split('imgsrc=')[1])
    : '';
  formState.certificate_rear.indexOf('imgsrc=') != -1
    ? (formState.certificate_rear = formState.certificate_rear.split('imgsrc=')[1])
    : '';
  http
    .user_authentication(formState)
    .then((res) => {
      message.success(res.data.message);
      editForm.value = false;
      formState.code = '';
      showCodeBtn.value = false;
      isShowcode.value = true;
      selectType.value == 1 ? (agreeStatus.value = 2) : (agreeStatus.value = 1);
      setCertificationStatus(agreeStatus.value);
      clearInterval(timer.value);
    })
    .catch((res) => {
      message.error(res.data.error);
      editForm.value = false;
    });
};
const reject_reason = ref('');
const enclosure = ref('');
const setFrom = (data: any) => {
  formState.name = data.name;
  formState.id_number = data.id_number;
  formState.contact_person = data.contact_person;
  formState.mobile = data.mobile;
  formState.address = data.address;
  formState.industry = data.industry;
  formState.certificate_front = data.certificate_front;
  formState.certificate_rear = data.certificate_rear;
  formState.certification_type = data.certification_type;
  reject_reason.value = data.reject_reason;
  enclosure.value = data.enclosure;
  for (var key in cityData) {
    cityData[key].forEach((item: any) => {
      if (item == data.industry) {
        province.value = key;
        secondCity.value = item;
        cities.value = cityData[province.value];
      }
      return;
    });
  }
};
// 认证时获取用户注册信息
const getRegisterInfo = () => {
  let params = {};
  http.get_register_info(params).then((res) => {
    regInfo.value = res.data.data;
    formState.mobile = regInfo.value.mobile;
    oldMobile.value = regInfo.value.mobile;
  });
};
// 用户获取认证资料
const userGetInfo = () => {
  let params = {
    time: new Date().getTime(),
  };
  showLoading.value = true;
  http
    .user_get_authentication_info({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.data) {
        agreeStatus.value = res.data.data.status;
        setCertificationStatus(res.data.data.status); // 更新认证状态
        agreeStatus.value == 0 ? (upView.value = true) : (upView.value = false);
        res.data.data.status != 0 ? (checked.value = true) : '';
        selectType.value = res.data.data.certification_type == 0 ? 2 : res.data.data.certification_type;
        selectType.value == 1 ? (rules.contact_person[0].required = false) : (rules.contact_person[0].required = true);
        oldMobile.value = res.data.data.mobile;
        frontImg.value = res.data.data.certificate_front;
        rearImg.value = res.data.data.certificate_rear;
        setFrom(res.data.data);
      } else {
        selectType.value = 2;
        modeList.value[0].checked = true;
        modeList.value[1].checked = false;
      }
    })
    .catch(() => {
      showLoading.value = false;
    });
};

// 初始化
getRegisterInfo();
userGetInfo();

const viewForm = ref<boolean>(false);
const upView = ref<boolean>(true);
const editForm = ref<boolean>(false);
const showCodeBtn = ref<boolean>(false);
const changeMobile = () => {
  oldMobile.value != formState.mobile ? (showCodeBtn.value = true) : (showCodeBtn.value = false);
};
let isShowcode = ref(true);
let timer: any = ref(0);
const TIME_COUNT = 60;
let count = ref(TIME_COUNT);
const getCode = () => {
  if (!timer.value) {
    count.value = TIME_COUNT;
    isShowcode.value = false;
    timer.value = setInterval(() => {
      if (count.value > 0 && count.value <= TIME_COUNT) {
        count.value--;
      } else {
        isShowcode.value = true;
        clearInterval(timer.value);
        timer.value = 0;
      }
    }, 1000);
  }
  // 获取验证码
  httpcode.sendCaptcha({ mobile: formState.mobile, type: 0 });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (showLoading.value)
      ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (agreeStatus.value != 2 && viewForm.value)
            ? (_openBlock(), _createBlock(_unref(aAlert), {
                key: 0,
                message: tipsMsg.value,
                type: "warning",
                "show-icon": ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          (agreeStatus.value != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (agreeStatus.value == 3)
                  ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 0,
                      class: "svgName",
                      "icon-class": "reject"
                    }))
                  : (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 1,
                      class: "svgName",
                      "icon-class": "authentication"
                    })),
                _createElementVNode("h2", null, _toDisplayString(agreeStatus.value == 1 ? '认证成功！' : agreeStatus.value == 2 ? '认证成功！' : '认证被驳回！'), 1),
                (agreeStatus.value == 3)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                      _createTextVNode(_toDisplayString(reject_reason.value), 1),
                      (enclosure.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: enclosure.value,
                            target: "_blank",
                            class: "primary_color_blue"
                          }, " 立即查看", 8, _hoisted_4))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (agreeStatus.value != 1 || viewForm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (agreeStatus.value != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h2", null, _toDisplayString(selectType.value == 2 ? '企业认证' : '个人认证'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(selectType.value == 2 ? '机构/企业名称' : '姓名') + "：", 1),
                          _hoisted_9,
                          _hoisted_10,
                          _withDirectives(_createElementVNode("p", null, "管理员姓名：", 512), [
                            [_vShow, selectType.value == 2]
                          ]),
                          _createElementVNode("p", null, _toDisplayString(selectType.value == 2 ? '企业邮箱' : '个人邮箱') + "：", 1),
                          _hoisted_11
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(selectType.value == 2 ? regInfo.value?.company : regInfo.value?.name), 1),
                          _createElementVNode("p", null, _toDisplayString(regInfo.value?.id), 1),
                          _createElementVNode("p", null, _toDisplayString(regInfo.value?.created_at), 1),
                          _withDirectives(_createElementVNode("p", null, _toDisplayString(regInfo.value?.name), 513), [
                            [_vShow, selectType.value == 2]
                          ]),
                          _createElementVNode("p", null, _toDisplayString(regInfo.value?.email), 1),
                          _createElementVNode("p", null, _toDisplayString(regInfo.value?.mobile), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modeList), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["switch_mode_type cursor", { active: item.type == selectType.value }]),
                            key: item.type,
                            onClick: _withModifiers(($event: any) => (getMode(item.type)), ["stop"])
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_svg_icon, {
                                class: "svg_icon",
                                "icon-class": item.icon
                              }, null, 8, ["icon-class"]),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_a_radio, {
                                  checked: item.checked,
                                  "onUpdate:checked": ($event: any) => ((item.checked) = $event)
                                }, null, 8, ["checked", "onUpdate:checked"])
                              ])
                            ])
                          ], 10, _hoisted_15))
                        }), 128))
                      ])
                    ])),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", {
                    class: "top cursor",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (agreeStatus.value != 0 ? (upView.value = !upView.value) : ''))
                  }, [
                    _createTextVNode(_toDisplayString(agreeStatus.value == 0 ? '填写基本信息' : '认证信息') + " ", 1),
                    (upView.value && agreeStatus.value != 0)
                      ? (_openBlock(), _createBlock(_unref(UpOutlined), { key: 0 }))
                      : (agreeStatus.value != 0)
                        ? (_openBlock(), _createBlock(_unref(DownOutlined), { key: 1 }))
                        : _createCommentVNode("", true)
                  ]),
                  (editForm.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_unref(aAlert), {
                          message: "温馨提示：修改认证数据后，需要重新审核，审核期间将无法创建直播",
                          type: "warning",
                          "show-icon": ""
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                      title: _withCtx(() => [
                        _hoisted_22
                      ]),
                      default: _withCtx(() => [
                        (agreeStatus.value != 0)
                          ? (_openBlock(), _createBlock(_unref(FormOutlined), {
                              key: 0,
                              class: "edit",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (editForm.value = !editForm.value))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadImg), (item) => {
                        return _withDirectives((_openBlock(), _createBlock(Ccertificates, {
                          key: item.type,
                          type: item.type,
                          disabled: agreeStatus.value != 0 && !editForm.value,
                          "file-list": fileList.value,
                          "handle-change": (info) => handleChange(info, item.change_type),
                          loading: loading[item.change_type],
                          "image-name": item.type == 2 ? rearImg.value : frontImg.value,
                          "click-stop": (info) => clearImg(item.change_type),
                          plus: false,
                          data: () => item.data,
                          class: _normalizeClass(["upload", { upload_two: selectType.value == 2 }]),
                          style: _normalizeStyle(selectType.value == 2 ? 'width: 419px; height: 143px' : '')
                        }, {
                          uploadImg: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              "icon-class": item.icon,
                              "font-size": "70px"
                            }, null, 8, ["icon-class"]),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(item.tips), 1)
                          ]),
                          _: 2
                        }, 1032, ["type", "disabled", "file-list", "handle-change", "loading", "image-name", "click-stop", "data", "class", "style"])), [
                          [_vShow, selectType.value == item.data.type]
                        ])
                      }), 128))
                    ]),
                    _createVNode(_unref(aForm), {
                      ref_key: "formRef",
                      ref: formRef,
                      class: "Form",
                      model: formState,
                      rules: _unref(rules),
                      "label-col": { span: 24 }
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formItem), (item, index) => {
                          return _withDirectives((_openBlock(), _createBlock(_unref(aFormItem), {
                            label: item.type == 0 ? (selectType.value == 1 ? item.label : item.label2) : item.label,
                            name: item.name,
                            required: item.type == 1 ? true : false,
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formState[item.value],
                                "onUpdate:value": ($event: any) => ((formState[item.value]) = $event),
                                disabled: agreeStatus.value != 0 && !editForm.value,
                                placeholder: selectType.value == 1 ? item.placeholder : item.placeholder2,
                                onChange: ($event: any) => (item.value == 'mobile' ? changeMobile() : ''),
                                style: {"width":"420px"}
                              }, null, 8, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"])
                            ]),
                            _: 2
                          }, 1032, ["label", "name", "required"])), [
                            [_vShow, selectType.value == item.type || item.type == 0 || item.type == 1]
                          ])
                        }), 128)),
                        (showCodeBtn.value)
                          ? (_openBlock(), _createBlock(_unref(aFormItem), {
                              key: 0,
                              label: "验证码",
                              name: "industry",
                              "wrapper-col": { span: 18 }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_a_input, {
                                    value: formState.code,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.code) = $event)),
                                    placeholder: "请输入验证码",
                                    style: {"width":"320px"}
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (getCode())),
                                    disabled: !_unref(isShowcode),
                                    style: {"width":"100px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(isShowcode) ? '获取验证码' : _unref(count)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(aFormItem), {
                          label: "所在行业",
                          name: "industry"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(aSpace), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(aSelect), {
                                  value: province.value,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((province).value = $event)),
                                  style: {"width":"205px"},
                                  disabled: agreeStatus.value != 0 && !editForm.value,
                                  options: _unref(provinceData).map((pro) => ({ lable: pro, value: pro })),
                                  onChange: selectChange
                                }, null, 8, ["value", "disabled", "options"]),
                                _createVNode(_unref(aSelect), {
                                  value: secondCity.value,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((secondCity).value = $event)),
                                  style: {"width":"205px"},
                                  disabled: agreeStatus.value != 0 && !editForm.value,
                                  options: cities.value.map((city) => ({ value: city })),
                                  onChange: selectChangeTwo
                                }, null, 8, ["value", "disabled", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aFormItem), { "wrapper-col": { span: 24 } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(aCheckbox), {
                                checked: checked.value,
                                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((checked).value = $event)),
                                disabled: agreeStatus.value != 0 && !editForm.value
                              }, null, 8, ["checked", "disabled"]),
                              _hoisted_27
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aFormItem), { "wrapper-col": { span: 24 } }, {
                          default: _withCtx(() => [
                            (agreeStatus.value == 0 || editForm.value)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: _withModifiers(onSubmit, ["prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(!editForm.value ? '提交' : '修改') + "认证", 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ], 512), [
                    [_vShow, upView.value]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})